
module.exports = [
  {
    name: "Simple Form",
    description: `
      A basic form containing star ratings and a feedback input. 
    `,
    template: require('./samples/defaultForm.hbs'),
    thankYouTemplate: require('./samples/defaultThankYou.hbs'),
    previewImg:  "/images/reviewBuilder/reviewForm/Default.jpg",
    placeholderLogo: "https://s3.amazonaws.com/cm-review-builder/commonImages/placeholder_logo.jpg",
    dynamicFields: {
      'text:ratingQuestion': "How would you rate your experience?",
      'text:detailQuestion': "Is there any feedback you would like to give us?",
      'text:heading': "Leave a Review",
      'text:submitText': "Submit",
      'text:starSelect': "(Select 1-5 stars)",
    }
  },
  {
    name: "Net Promoter Form",
    description: `
      A form containing a net promoter score question and a feedback input.
    `,
    template: require('./samples/deluxeForm.hbs'),
    thankYouTemplate: require('./samples/deluxeThankYou.hbs'),
    previewImg:  "/images/reviewBuilder/reviewForm/Deluxe.jpg",
    placeholderLogo: "https://s3.amazonaws.com/cm-review-builder/commonImages/placeholder_logo.jpg",
    dynamicFields: {
      'text:ratingQuestion': "How would you rate your experience with us?",
      'text:netPromoterQuestion': "How likely is it that you would recommend us to a friend or colleague?",
      'text:detailQuestion': "Please provide any additional feedback you might have for us.",
      'text:heading': "Leave a Review",
      'text:submitText': "Submit"
    }
  }
];
